import {
  Toaster,
  Toast,
  ToastTitle,
  useToastController,
  ToastIntent,
} from "@fluentui/react-components";
import { PropsWithChildren } from "react";
import { ToastContext } from "./ToasterContext";

export function ToastProvider({ children }: PropsWithChildren) {
  const toasterId = "global-toaster";

  const { dispatchToast } = useToastController(toasterId);

  const showToast = (
    message: string,
    intent: ToastIntent = "info" // default
  ) => {
    let border: string;
    let background;

    switch (intent) {
      case "success":
        border = "#9fd89f";
        background = "#f1faf1";
        break;

      case "error":
        border = "#eeacb2";
        background = "#fdf3f4";
        break;

      case "warning":
        border = "#fdcfb4";
        background = "#fff9f5";
        break;

      default:
        border = "#d1d1d1";
        background = "#f5f5f5";
    }

    return dispatchToast(
      <Toast
        style={{
          backgroundColor: background,
          borderColor: border,
        }}
      >
        <ToastTitle>{message}</ToastTitle>
      </Toast>,
      { intent }
    );
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      <Toaster
        toasterId={toasterId}
        position="top"
        pauseOnHover
        pauseOnWindowBlur
        timeout={2500}
        offset={{ vertical: 60 }}
      />
      {children}
    </ToastContext.Provider>
  );
}
